export class WorkersExportRequest {

    _page; // number
    _term; // string
    _companyId; // number
    _workerStateIds; // number[]

    constructor(companyId = undefined) {
        this._page = 1;
        this._term = '';
        this._companyId = companyId;
        this._workerStateIds = undefined;
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setWorkerState(workerState) {
        this._workerStateIds =
            workerState === 1 || workerState === 2
                ? [workerState]
                : undefined;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                company_id: this._companyId,
                worker_state_ids: this._workerStateIds,
                show_only_deleted: false,
                include_only_company_workers: true,
                include_only_contractor_workers: undefined,
                retrieve_worker_documentation_state: true,
                skip_contractors_inactive: true,
                skip_companies_inactive: true,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/list/workers-export/WorkersExportRequest.js